__turbopack_context__.v({
  "cookieItem": "CookieList-module-scss-module__k3Ncja__cookieItem",
});
